import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
	},
	item: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
		alignItems: 'center',
		position: 'relative',
	},
	fakeicon: {
		flex: '0 0 24px',
		height: 24,
	},
	icon: {
		position: 'absolute',
		top: 0,

		'> svg': {
			display: 'block',
		},
	},
}));
